/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_N7Inputs */

const en_to_csv_ref_n7 = /** @type {(inputs: To_Csv_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booleans and numbers are written bare, exactly as they read in JSON.`)
};

const ko_to_csv_ref_n7 = /** @type {(inputs: To_Csv_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`불리언과 숫자는 JSON에서 읽히는 그대로 작성됩니다.`)
};

const ja_to_csv_ref_n7 = /** @type {(inputs: To_Csv_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真偽値と数値は JSON で読めるそのままの形で書かれます。`)
};

/**
* | output |
* | --- |
* | "Booleans and numbers are written bare, exactly as they read in JSON." |
*
* @param {To_Csv_Ref_N7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_n7 = /** @type {((inputs?: To_Csv_Ref_N7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_N7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_n7(inputs)
	if (locale === "ko") return ko_to_csv_ref_n7(inputs)
	return ja_to_csv_ref_n7(inputs)
});